import { StatColumn } from "@bridgesplit/ui";
import { combineCollections } from "@bridgesplit/utils";

import { useRaydiumContext } from "../RaydiumContext";
import { useHealthChangeStats, useTokenAmountStats } from "../../clmm";
import { useDepositLtv } from "./util";

export default function DepositCtaStats() {
    const { depositForm, raydiumPosition } = useRaydiumContext();
    const depositLtv = useDepositLtv();
    const healthChangeStats = useHealthChangeStats(depositLtv);

    const tokenAmountStats = useTokenAmountStats({
        tokenAChange: depositForm.tokenAAmount ?? 0,
        tokenBChange: depositForm.tokenBAmount ?? 0,
        tokenA: raydiumPosition.tokenA,
        tokenB: raydiumPosition.tokenB
    });
    if (!depositForm.tokenAAmount || !depositForm.tokenBAmount) return null;

    return (
        <StatColumn loading={depositLtv.isLoading} stats={combineCollections([tokenAmountStats, healthChangeStats])} />
    );
}
